import { RecordUser } from './RecordUser';

export class RecordItem {
    id?: number;
    record_name?: string;
    record_description?: string;
    created_at?: string;
    record_creator_id?: number;
    record_currency_code?: string;
    record_invite_code?: number;
    permissions?: RecordUser[];

    constructor(init?: Partial<RecordItem>) {
        Object.assign(this, init);
    }

    /**
     * Creates a RecordItem from a JSON object
     */
    static fromJSON(json: any): RecordItem {
        const permissions: RecordUser[] = [];
        const permissionsArray = json.permissions;
        
        if (permissionsArray && Array.isArray(permissionsArray)) {
            permissionsArray.forEach((permission: any) => {
                permissions.push(new RecordUser({
                    user_id: permission.user_id,
                    username: permission.username,
                    imageUrl: permission.image_url,
                    record_id: permission.record_id?.toString(),
                    can_read: permission.can_read?.toString(),
                    can_write: permission.can_write?.toString()
                }));
            });
        }

        return new RecordItem({
            id: json.id,
            record_name: json.record_name,
            record_description: json.record_description,
            created_at: json.created_at,
            record_creator_id: json.record_creator_id,
            record_currency_code: json.record_currency_code,
            record_invite_code: json.record_invite_code,
            permissions
        });
    }

    toString(): string {
        return this.record_name || '';
    }

    equals(other: RecordItem): boolean {
        return this.id === other.id;
    }

    // Helper method to create mock data
    static createMock(id: number, record_name: string, record_description: string, createdAt: string, currencyCode: string, inviteCode: number): RecordItem {
        return new RecordItem({
            id,
            record_name,
            record_description,
            created_at: createdAt,
            record_currency_code: currencyCode,
            record_invite_code: inviteCode,
            permissions: []
        });
    }
}